import { Component, OnInit, Input } from "@angular/core";

type DataTypes = "height" | "weight" | "score" | "percentile";

@Component({
  selector: "tr-data",
  template: `
    <tr [class]="class">
      <td
        scope="row"
        [ngClass]="{ 'text-right': textRight, 'text-center': !textRight }"
        class="table-right-data {{ titleClass }}"
        [ngStyle]="titleStyle"
      >
        {{ title }}
      </td>
      <td
        *ngFor="let item of cols; let i = index"
        [ngStyle]="item.style"
        [ngSwitch]="item.type"
      >
        <height-value
          *ngSwitchCase="'height'"
          [height]="item.data"
          [textRight]="textRight"
        ></height-value>
        <weight-value
          *ngSwitchCase="'weight'"
          [weight]="item.data"
          [textRight]="textRight"
        ></weight-value>
        <score-value *ngSwitchCase="'score'" [score]="item.data"></score-value>
        <percentile-value
          *ngSwitchCase="'percentile'"
          [percentile]="item.data"
          [textRight]="textRight"
        ></percentile-value>
        <report-value *ngSwitchDefault>{{ item.data }}</report-value>
      </td>
    </tr>
  `,
  styles: [
    `
      :host {
        display: contents;
      }
      .table-right-data {
        font-size: 11px;
        line-height: 1.5;
      }

      .font {
        font-size: 14px;
      }
    `,
  ],
})
export class TrDataComponent implements OnInit {
  @Input() title: string;
  @Input() cols: any[] = [];
  @Input() class?: string;
  @Input() titleClass?: string = "";
  @Input() textRight?: boolean = true;
  public titleStyle;

  constructor() {}
  ngOnInit() {
    this.titleStyle = this.cols[0].style;
  }
}
